import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, Checkbox } from '@mui/material';

const SearchPartnerItemComponent = ({ item, isPF, onToggleSelectItem }) => {
  const handleSelectItem = useCallback(id => () => onToggleSelectItem(id), [onToggleSelectItem]);

  return (
    <>
      {!isPF ? (
        <>
          <TableRow>
            <TableCell size={'small'}>
              <Checkbox id={`partner_${item.partnerId}`} checked={item.selected || false} onChange={handleSelectItem(item.partnerId)} />
            </TableCell>
            <TableCell>{item.uniqueId || '-'}</TableCell>
            <TableCell>{item.name || '-'}</TableCell>
            <TableCell>{item.legalForm || '-'}</TableCell>
          </TableRow>
        </>
      ) : (
        <>
          <TableRow>
            <TableCell size={'medium'}>
              <Checkbox id={`partner_${item.partnerId}`} checked={item.selected || false} onChange={handleSelectItem(item.partnerId)} />
            </TableCell>
            <TableCell>{item.fullName || '-'}</TableCell>
            <TableCell>{item.citizenship || '-'}</TableCell>
            <TableCell>{item.idSeriesAndNumber || '-'}</TableCell>
            <TableCell>{item.birthDate || '-'}</TableCell>
            <TableCell>{item.country || '-'}</TableCell>
            <TableCell>{item.county || '-'}</TableCell>
            <TableCell>{item.city || '-'}</TableCell>
          </TableRow>
        </>
      )}
    </>
  );
};

SearchPartnerItemComponent.propTypes = {
  item: PropTypes.object.isRequired,
  isPF: PropTypes.bool.isRequired,
  onToggleSelectItem: PropTypes.func.isRequired
};

export default SearchPartnerItemComponent;
